var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import Card from 'react-bootstrap/Card';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Card, { className: "mb-4" },
                React.createElement(Card.Header, null, "Price Discount"),
                React.createElement(Card.Body, null,
                    React.createElement(Card.Text, null, "XXX"))));
    };
    return default_1;
}(React.Component));
export default default_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJpY2VEaXNjb3VudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlByaWNlRGlzY291bnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEtBQUssS0FBSyxNQUFNLE9BQU8sQ0FBQztBQUMvQixPQUFPLElBQUksTUFBTSxzQkFBc0IsQ0FBQztBQUV4QztJQUE2Qiw2QkFBZTtJQUE1Qzs7SUFlQSxDQUFDO0lBZEMsMEJBQU0sR0FBTjtRQUNFLE9BQU87WUFDTCxvQkFBQyxJQUFJLElBQUMsU0FBUyxFQUFDLE1BQU07Z0JBQ3BCLG9CQUFDLElBQUksQ0FBQyxNQUFNLHlCQUVFO2dCQUNkLG9CQUFDLElBQUksQ0FBQyxJQUFJO29CQUNSLG9CQUFDLElBQUksQ0FBQyxJQUFJLGNBRUUsQ0FDRixDQUNQLENBQ04sQ0FBQTtJQUNMLENBQUM7SUFDSCxnQkFBQztBQUFELENBQUMsQUFmRCxDQUE2QixLQUFLLENBQUMsU0FBUyxHQWUzQyJ9